import React, { useState, useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import adminImage from "../Assests/expertimgg.jpg";
import "./AdminDashboard.css";

function AdminDashboard() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userRole = localStorage.getItem("role");

    if (userRole !== "admin") {
      navigate("/login-in");
    }
  }, [navigate]);

  const toggleDropdown = (section) => {
    setActiveDropdown(activeDropdown === section ? null : section);
  };

  const getArrow = (section) => (activeDropdown === section ? "▲" : "▼");

  const handleSignOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login-in");
  };

  return (
    <div className="admin-dashboard">
      {/* Sidebar */}
      <div className="admin-sidebar">
        <div className="sidebar-header">
          <img src={adminImage} alt="Admin" className="admin-image" />
          <h2 className="sidebar-title">Admin Panel</h2>
        </div>
        <nav className="sidebar-links">
          {/* Contact Person */}
          <div
            className={`sidebar-link ${
              activeDropdown === "contact-person" ? "active" : ""
            }`}
            onClick={() => navigate("contact-person")}
          >
            <span className="icon">
              <i className="fas fa-calendar-check"></i>
            </span>{" "}
            Contact Person
          </div>

          {/* Career Dropdown */}
          <div
            className="sidebar-link"
            onClick={() => toggleDropdown("career-option")}
          >
            <span className="icon">
              <i className="fas fa-calendar-day"></i>
            </span>
            Career Option
            <span className="arrow">{getArrow("career-option")}</span>
          </div>
          <div
            className={`dropdown-container ${
              activeDropdown === "career-option" ? "show" : ""
            }`}
          >
            <Link to="pharmasist-form" className="dropdown-item">
              Pharmasist
            </Link>
            <Link to="accountant-form" className="dropdown-item">
              Accountant
            </Link>
            <Link to="warehouse-manger-form" className="dropdown-item">
              WareHouse Manger
            </Link>
            <Link to="warehouse-executive-form" className="dropdown-item">
              WareHouse Executive
            </Link>
            <Link to="sales-executive-form" className="dropdown-item">
              Sales Executive
            </Link>
          </div>
        </nav>

        {/* Sign-Out Button */}
        <div
          className="sidebar-link sidebar-link-signout"
          onClick={handleSignOut}
        >
          <span className="icon">
            <i className="fas fa-sign-out-alt"></i>
          </span>{" "}
          Sign Out
        </div>
      </div>

      {/* Main Content Area */}
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
}

export default AdminDashboard;